// extracted by mini-css-extract-plugin
module.exports = {"root":"generic-step_root__3jfT_","header":"generic-step_header__3I56U","companyCardWrapper":"generic-step_companyCardWrapper__RCrnr","content":"generic-step_content__sTEK2"};